<template>
    <div>
        <div class="steps" >
           
            <div v-for="(item,index) in stepinfos" :key="index" @click="clickstep(index)" :class="active==index?'active step':'step'">
                <div class="step-bg" >
                    <div class="bg-w">
                        <div class="bg-n">{{item.steptxt}}</div>
                    </div>
                    <div class="step-line" v-if="index!=stepinfos.length-1"></div>
                </div>
                <div class="step-txt">{{item.txt}}</div>
            </div>
		</div>
    </div>
</template>
<script>
export default {
    name:"mystep",
    props:{
        stepinfos:{
            type: Array,
			default:()=>[]
        },
        active:{
            type:Number,
            default:0
        }
    },
    data(){
        return {

        }
    },
    methods:{
        clickstep(index)
        {
            
            this.$emit('changed',index);
        }
    }
}
</script>
<style lang="scss" scoped>
    .steps{
        font-size: 15px;
        text-align: left;
        margin-left: 40px;
		font-weight: bold;
    }
    .step{
		display: inline-block;
		width: 33%;
		position: relative;
	}
	
	.step-bg{
		min-height: 30px;
		width: 100%;
		position: relative;
	}
	
	.bg-w{
		background-color:#FFF0AB;
		color: white;
		position: absolute;
		width: 30px;
		height: 30px;
		border-radius: 50%;
		top: 0;
		left:6px;
		z-index: 999999;
	}
	
	.bg-n {
		position: relative;
		width: 30px;
		height: 30px;
		border-radius: 50%;
		text-align: center;
		transform: (0,-50%);
		transform: translate(-50%, -50%);
		top: 50%;
		left: 50%;
        line-height: 30px;
	}
	
	.step-line{
		background-color:#85c56f;;
		height: 4px;
		position: absolute;
		left: 31px;
		top: 13px;
		right: -18px;
		z-index:99;
	}
	
	.steps .step .bg-n{
		background-color: #85c56f;;
	}
	
	.steps .step .step-line{
		background-color:#85c56f;;
	}
	.active~div .bg-n{
		background-color: #d0fac2 !important;
	}
	.active~div .step-line,.active .step-line{
		background-color:#d0fac2 !important;
	}
	.active .step-line{
		left:34px;
	}
	.step-txt{
        margin-top: 10px;
        color:#85c56f;;
        font-size: 12px;
    }
</style>
